
import { cn } from '@/lib/utils';
import { FormLabel } from './form-label';
import { ValidationMessage } from './validation-message';

interface FormFieldWrapperProps {
  label: string;
  required?: boolean;
  error?: string;
  success?: string;
  children: React.ReactNode;
  className?: string;
  labelClassName?: string;
  errorType?: 'default' | 'warning' | 'popup';
}

export const FormFieldWrapper = ({ 
  label, 
  required = false,
  error,
  success,
  children,
  className,
  labelClassName,
  errorType = 'default'
}: FormFieldWrapperProps) => {
  const getValidationMessageType = () => {
    if (errorType === 'warning') return 'warning';
    if (errorType === 'popup') return 'popup';
    return 'error';
  };

  return (
    <div className={cn("space-y-2", className)}>
      <FormLabel required={required} className={labelClassName}>
        {label}
      </FormLabel>
      {children}
      {error && <ValidationMessage type={getValidationMessageType()} message={error} />}
      {success && !error && <ValidationMessage type="success" message={success} />}
    </div>
  );
};
